<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Comparables Filter</h3>
    </div>
  </div>

  <form class="form">
    <div class="card-body">
      <mat-dialog-content>
        <cdk-accordion class="filter-accordion">
          <cdk-accordion-item
            *ngFor="let section of sections; trackBy: trackByKey"
            #accordionItem="cdkAccordionItem"
            class="filter-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-' + section.descriptor.key"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'accordion-body-' + section.descriptor.key"
          >
            <div class="filter-accordion-item-header" (click)="accordionItem.toggle()">
              {{ section.descriptor.label }}
            </div>
            <div
              class="filter-accordion-item-body"
              role="region"
              [style.display]="accordionItem.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-' + section.descriptor.key"
              [attr.aria-labelledBy]="'accordion-header-' + section.descriptor.key"
            >
              <!-- Value search — applies to every column. -->
              <input #searchEl type="text" class="form-control form-control-sm filter-search"
                placeholder="Search"
                [value]="section.search"
                (input)="onSearch(section, searchEl.value)" />

              <!-- Numeric columns (e.g. BUA): From/To range. -->
              <ng-container *ngIf="section.descriptor.type == 'number'">
                <div class="range-row">
                  <span class="range-label">From</span>
                  <input #minEl type="number" class="form-control form-control-sm"
                    placeholder="Low"
                    [value]="range(section).min"
                    (input)="onChangeRange(section, 'min', minEl.value)" />
                  <span class="range-label">to</span>
                  <input #maxEl type="number" class="form-control form-control-sm"
                    placeholder="High"
                    [value]="range(section).max"
                    (input)="onChangeRange(section, 'max', maxEl.value)" />
                </div>
              </ng-container>

              <!-- Date columns: narrow to a month and/or year. -->
              <ng-container *ngIf="section.descriptor.type == 'date'">
                <div class="range-row">
                  <span class="range-label">Month</span>
                  <input #monthEl type="number" min="1" max="12" class="form-control form-control-sm"
                    placeholder="MM"
                    [value]="parts(section).month"
                    (input)="onChangeMonth(section, monthEl.value)" />
                  <span class="range-label">Year</span>
                  <input #yearEl type="number" class="form-control form-control-sm"
                    placeholder="YYYY"
                    [value]="parts(section).year"
                    (input)="onChangeYear(section, yearEl.value)" />
                </div>
              </ng-container>

              <div class="checkbox-list" *ngIf="section.values.length > 0">
                <mat-checkbox [checked]="allTicked(section)" (change)="onToggleAll(section, $event)">
                  Select All
                </mat-checkbox>
                <mat-checkbox *ngFor="let value of visibleValues(section); trackBy: trackByIndex"
                  [checked]="isTicked(section, value)"
                  (change)="onToggleValue(section, value, $event)"
                >
                  <ng-container [ngSwitch]="section.descriptor.type">
                    <ng-container *ngSwitchCase="'date'">
                      {{ value === null ? section.descriptor.emptyLabel : (value|date:'dd MMM yyyy') }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number'">
                      {{ value === null ? section.descriptor.emptyLabel : (value|number:'1.0-2') }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{ label(section, value) }}</ng-container>
                  </ng-container>
                </mat-checkbox>
              </div>

              <!-- A capped list must say it is capped; a silent prefix reads as the whole set. -->
              <div class="filter-note" *ngIf="section.truncated">
                Too many values to list them all.
                <ng-container *ngIf="section.descriptor.type == 'number'">Use From/To above, or</ng-container>
                narrow the other columns first.
              </div>

              <div class="filter-note" *ngIf="section.values.length == 0 && !section.truncated">
                No values under the current filter.
              </div>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      </mat-dialog-content>
    </div>
    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-lg-12">
            <button type="button" mat-raised-button cdkFocusInitial (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
